module.exports = __webpack_public_path__ + "img/index_weather04.17a9c683.png";